<div class="u-relative">
  @if (config.description) {
    <div class="FormGroupArray__Description t-data t-bold">
      {{ config.description }}
    </div>
  }

  @if (formArray.controls?.length > 0) {
    @if (config.showFormWithAccordion) {
      <div>
        <form-group-array-accordion-content
          [formArray]="formArray"
          [config]="config"
          [context]="context"
          [openedAccordionIndex]="openedAccordionIndex"
          (addDuplicateClicked)="addDuplicate($event)"
          (removeGroupClicked)="removeGroup($event)"
        >
        </form-group-array-accordion-content>
      </div>
    } @else {
      <form-group-array-content
        [formArray]="formArray"
        [config]="config"
        [context]="context"
        (addDuplicateClicked)="addDuplicate($event)"
        (removeGroupClicked)="removeGroup($event)"
      >
      </form-group-array-content>
    }
    <form-group-array-footer
      [config]="config"
      [formArray]="formArray"
      [context]="context"
      (addFormGroupClicked)="addGroup()"
    ></form-group-array-footer>
  } @else {
    @if (config.errorEmpty) {
      <error-empty [config]="config.errorEmpty"> </error-empty>
    }
    @if (config.showAddButtonWhenNoGroups) {
      <zip-button
        [config]="config.addButton"
        (zipButtonClicked)="addGroup()"
      ></zip-button>
    }
  }
</div>
